export default [
  {
    width: '40px',
    value: 'edit',
    align: 'center',
    colModifiers:[
      { type: 'edit' }
    ],
    editPath: 'legal-entities/edit/'
  },
  { text: 'Сеть', value: 'network' },
  { text: 'Торговая марка', value: 'trademark' },
  { text: 'Юр. лицо', value: 'name' }
]
